import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {Subject} from 'rxjs';

import {AlertaModel} from './Modelo/Alerta.model';
import {AlertaEnum, DialogoEnum} from './Enumeraciones/MensajeEnumeraciones.enum';
import {InformacionModel} from './Modelo/Informacion.model';
import {Defer, Dialogo, DialogoOpcion} from './Modelo/Dialogo.model';

@Injectable()

export class MensajeService
{
  private alertaSubject = new Subject<any>();
  private alertaTimerSubject = new Subject<any>();
  private informacionSubject = new Subject<any>();
  private dialogoSubject = new Subject<any>();
  private id:number = 0;

  private dialogoRespuesta:any;
  private alertaTimerRespuesta:any;

  constructor()
  {
  }

  //-- Alerta --
  IniciarAlerta(): Observable<any>
  {
    return this.alertaSubject.asObservable();
  }

  Alerta(Tipo : AlertaEnum, Descripcion : string, Remove = true)
  {
    this.id++;
    this.alertaSubject.next(<AlertaModel>{Tipo:Tipo, Descripcion:Descripcion, AlertaId:this.id, Remove: Remove, Icono:""});
  }

  TerminarAlerta(terminado : boolean)
  {
    this.alertaTimerRespuesta.resolve(terminado);
  }

  //-- Alerta Timer --
  IniciarAlertaTimer(): Observable<any>
  {
    return this.alertaTimerSubject.asObservable();
  }

  AlertaTimer(Tipo : AlertaEnum, Descripcion : string, Tiempo = 0)
  {
    this.alertaTimerRespuesta = new Defer<boolean>();

    this.alertaTimerSubject.next(<AlertaModel>{Tipo:Tipo, Descripcion:Descripcion, AlertaId:this.id, Tiempo : Tiempo});

    return this.alertaTimerRespuesta.promise;
  }

  //-- Mensaje Información --
  IniciarMensajeInformacion()
  {
    return this.informacionSubject.asObservable();
  }

  Mensaje(informacion : InformacionModel)
  {
    this.informacionSubject.next(informacion);
  }

  //-- Dialogos --
  IniciarDialogo()
  {
    return this.dialogoSubject.asObservable();
  }

  Dialogo(Tipo : DialogoEnum, Titulo : string,  Mensaje : string, Opcion : Array<DialogoOpcion>) : Promise<any>
  {
    this.dialogoRespuesta = new Defer<boolean>();

    this.dialogoSubject.next(new Dialogo({Tipo: Tipo, Titulo: Titulo, Mensaje:Mensaje, Opcion:Opcion}));

    return this.dialogoRespuesta.promise;
  }

  EnviarRespuestaDialogo(respuesta : any)
  {
    this.dialogoRespuesta.resolve(respuesta);
  }
}
